<div class="company-administration-container container" fxLayout="column" fxLayoutGap="30px">
  <mtn-company-alerts-panel [company]="company" (update)="loadCompany()"></mtn-company-alerts-panel>

  <div class="page-header container" fxLayout="column" fxLayoutGap="15px">
    <div fxLayout="row" fxLayoutGap="15px">
      <mtn-company-initials-avatar *ngIf="company" [company]="company"></mtn-company-initials-avatar>
      <div class="company-description" fxLayout="column" fxFlex="40">
        <h1 class="mat-h1 color-primary text-small-caps" style="margin-bottom:0">
          {{ company?.name }}
          <span class="color-muted" [matTooltip]="identifierTooltip">
            ({{ company?.uniqueIdentifier }})
          </span>
        </h1>
        <span class="color-muted">
          {{ company?.description || ('companyAdmin.noDescription' | translate) }}
        </span>
      </div>
      <div fxFlex></div>

      <mtn-icon-button [disabled]="true" matTooltip="Feature disabled for Insights entitlements">
        <fa-icon icon="pencil-alt"></fa-icon>
      </mtn-icon-button>
      <mtn-icon-button color="warn" [disabled]="true" matTooltip="Feature disabled for Insights entitlements">
        <fa-icon icon="trash-alt"></fa-icon>
      </mtn-icon-button>
    </div>
    <hr/>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" *ngIf="company">
    <div fxLayout="column" fxLayoutGap="30px">
      <mtn-company-api-key [company]="company" (update)="loadCompany()"></mtn-company-api-key>
      <mtn-company-api-user [company]="company" (update)="loadCompany()"></mtn-company-api-user>
      <mtn-company-add-on-list [company]="company"></mtn-company-add-on-list>
      <mtn-license-card [company]="company" (update)="loadCompany()"></mtn-license-card>
      <mtn-license-history-panel [company]="company"></mtn-license-history-panel>
    </div>
    <div fxFlex fxLayout="column" fxLayoutGap="30px">
      <mtn-company-users-list [company]="company" (update)="loadCompany()"></mtn-company-users-list>
      <mtn-area-subscriptions-list [company]="company"></mtn-area-subscriptions-list>
    </div>
  </div>
</div>
